import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap, withLatestFrom, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { SubscriberService } from '../../services/subscriber.service';
import { AppState } from '../app.state';
import { selectCartItems } from '../cart/cart.selectors';
import { CartItem } from '../cart/cart.state';
import { ProductV2 } from '../../models/product-v2.model';

import { AvailableOffersFacade } from './available-offers.facade';
import * as AvailableOffersActions from './available-offers.actions';

@Injectable()
export class AvailableOffersEffects {
  private readonly actions$ = inject(Actions);
  private readonly subscriberService = inject(SubscriberService);
  private readonly store = inject(Store<AppState>);
  private readonly availableOffersFacade = inject(AvailableOffersFacade);

  loadAvailableOffers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AvailableOffersActions.loadAvailableOffers),
      switchMap(({ cnpj }) =>
        this.subscriberService.getAvailableOffers({ cnpj }).pipe(
          map(response => AvailableOffersActions.loadAvailableOffersSuccess({ response })),
          catchError(error => of(AvailableOffersActions.loadAvailableOffersFailure({
            error: error.message || 'Erro ao carregar ofertas disponíveis'
          })))
        )
      )
    )
  );

  // Re-mapear produtos quando AvailableOffers são carregados
  remapProductsAfterLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AvailableOffersActions.loadAvailableOffersSuccess),
      withLatestFrom(this.store.select(selectCartItems)),
      tap(([_action, cartItems]) => {
        const productsMap = new Map<string, ProductV2>();
        cartItems.forEach((item: CartItem) => {
          if (item.product && !productsMap.has(item.product.uuid)) {
            productsMap.set(item.product.uuid, item.product);
          }
        });
        productsMap.forEach((product: ProductV2) => {
          this.availableOffersFacade.mapProductVariationsToOffers(product);
        });
      })
    ),
    { dispatch: false }
  );
}

